@if (!(isLoadingAddress$ | async)) {
  @if (page$ | async; as page) {
    @if (cards$ | async; as cards) {
      <div [class.page-checkout-block]="isCheckout(page)">
        @if (!forceLoader ) {
          @if (
            isAccountPayment || (cards?.length && !addressFormOpened)) {
            @if (!showEditAddressForm) {
              <div class="header-address-checkout">
                @if (cards?.length > 1) {
                  <h5> {{ 'checkoutAddress.selectShippingAddress' | cxTranslate }}</h5>
                }
                @if (!isAccountPayment) {
                  <div class="cx-checkout-btns row hidden-mobile">
                    <div class="col-sm-12 col-md-12 d-flex justify-content-end">
                      <button class="new-address-form" (click)="showNewAddressForm()">
                        <app-custom-icons [type]="iconTypes.PLUS"></app-custom-icons>
                        <span>{{ 'checkoutAddress.addNewAddress' | cxTranslate }}</span>
                      </button>
                    </div>
                  </div>
                }
              </div>
              <br>
                <div class="cx-checkout-body card-list">
                  @for (card of cards; track card; let i = $index) {
                    <cx-card [border]="true" [fitToContainer]="true"
                      [content]="getCardContentObservable(card.address) | async"
                      (editCard)="editAddressButtonHandle(card.address)" [length]="cards.length > 1" [shippingCards]="true"
                      (setDefaultCard)="customSetAddressAsDefault(card.address.id, card.address)"
                    (deleteCard)="setEdit(card.address.id)" (cancelCard)="cancelCard()" class="card-{{i}}"></cx-card>
                  }
                </div>
                <div class="cx-checkout-btns row">
                  <div class="col-lg-5 new-address-container hidden-mobile">
                    <button class="btn btn-white btn-block" (click)="back()">
                      <span>
                        {{ backBtnText | cxTranslate }}
                      </span>
                    </button>
                  </div>
                  <div class="col-sm-12 new-address-container hidden-desktop">
                    <button class="btn-block new-address-form" (click)="back()">
                      <span>
                        {{ backBtnText | cxTranslate }}
                      </span>
                    </button>
                  </div>
                  @if (!isAccountPayment) {
                    <div class="col-sm-12 hidden-desktop">
                      <button class="btn btn-block btn-white" (click)="showNewAddressForm()">
                        {{ 'checkoutAddress.addNewAddress' | cxTranslate }}
                      </button>
                    </div>
                  }
                  <div class="col-sm-12 col-lg-7">
                    <button class="cx-btn btn btn-block btn-black" (click)="next()">
                      {{ 'checkoutAddress.sendTo' | cxTranslate }}
                    </button>
                  </div>
                </div>
              } @else {
                <cx-address-form showTitleCode="true" actionBtnLabel="{{ 'addressBook.updateAddress' | cxTranslate }}"
                  cancelBtnLabel="{{ 'addressBook.backToAddressList' | cxTranslate }}" [addressData]="currentAddress"
                  (submitAddress)="editAddressCheckoutSubmit($event)" (backToAddress)="hideEditAddressForm()">
                </cx-address-form>
              }
            } @else {
              @if (cards.length) {
                <cx-address-form [showTitleCode]="false" [reset]="true"
                (backToAddress)="hideNewAddressForm()" (submitAddress)="addAddress($event)"></cx-address-form>
              } @else {
                <cx-address-form [showTitleCode]="false" [reset]="false" [setAsDefaultField]="!isGuestCheckout"
                  [addressData]="selectedAddress"
                  cancelBtnLabel="{{ backBtnText | cxTranslate }}"
                  (backToAddress)="hideNewAddressForm(true)"
                (submitAddress)="addAddress($event)"></cx-address-form>
              }
            }
          } @else {
            <div class="cx-spinner">
              <cx-spinner></cx-spinner>
            </div>
          }
        </div>
      }
    }
  } @else {
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
  }

